// Every page root is compiled from the server-rendered DOM, so a "${…}" or
// "{{…}}" that a visitor typed into a post title would be evaluated as a
// template expression in the next reader's browser. Attributes are never
// interpolated, only text, so splitting each opener with a zero-width space
// keeps the text readable and inert. Elements under v-pre are left alone:
// Vue skips them, and code blocks must copy out byte for byte.
const OPENER = /(\$|\{)(?=\{)/g;

export default function guardVueDelimiters(root) {
  if (!root) return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let node;
  while ((node = walker.nextNode())) {
    const text = node.data;
    if (!text.includes("${") && !text.includes("{{")) continue;
    if (node.parentElement && node.parentElement.closest("[v-pre]")) continue;
    node.data = text.replace(OPENER, "$1\u200B");
  }
}
